<script setup lang="ts">
import { useRoutes } from '@glow/shared/lib/routes';
import { ServiceListItem } from '@/features/services';
import type { RouteLocationRaw } from 'vue-router';
import { specializations } from '@glow/shared/features/specializations';

useHead({ title: 'Специальности' });

const { getUrl } = useRoutes();
const { staticUrl } = useRuntimeConfig().public;

type Item = {
  name: string;
  coverUrl: string;
  link: RouteLocationRaw;
};
const items = computed<Item[]>(() => [
  {
    name: 'Все специальности',
    coverUrl: `${staticUrl}/images/services/26.jpg`,
    link: getUrl('partnerCatalog', {
      city: 'moscow',
      type: 'master',
    }),
  },
  ...specializations.map((specialization) => ({
    name: specialization.name,
    coverUrl: `${staticUrl}/images/specializations/${specialization.id}.png`,
    link: getUrl('services', {
      specialization: specialization.slug,
    }),
  })),
]);
</script>

<template>
  <div>
    <NuxtLayout name="app">
      <h1>Специальности</h1>
      <div class="specializations">
        <NuxtLink
          v-for="item in items"
          :key="item.name"
          class="service"
          :to="item.link"
        >
          <ServiceListItem :name="item.name" :image-url="item.coverUrl" />
        </NuxtLink>
      </div>
    </NuxtLayout>
  </div>
</template>

<style scoped lang="scss">
.specializations {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--app-spacing-4);

  @include media-breakpoint-down(md) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--app-spacing-3);
  }
}
</style>
